export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedor"])},
          "total_number_attachs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["adjuntos"])},
          "destroy_button_attach_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar ", _interpolate(_named("file"))])},
          "destroy_button_attach_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar el adjunto?"])},
          "destroy_button_attach_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to containers list"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container"])},
          "total_number_attachs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total of attachs"])},
          "destroy_button_attach_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Delete ", _interpolate(_named("file"))])},
          "destroy_button_attach_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to delete the attach?"])},
          "destroy_button_attach_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
        }
      }
    }
  })
}